import Vue from "vue";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import BugsnagPerformance from "@bugsnag/browser-performance";
const {
  VUE_APP_BUGSNAG_KEY,
  VUE_APP_ENV,
  VUE_APP_VERSION,
  VUE_APP_BUILD
} = process.env;

export const bugSnagClient = VUE_APP_BUGSNAG_KEY
  ? Bugsnag.start({
      plugins: [new BugsnagPluginVue(Vue)],
      enabledReleaseStages: ["production", "staging"],
      releaseStage: VUE_APP_ENV,
      apiKey: VUE_APP_BUGSNAG_KEY,
      appVersion:
        VUE_APP_ENV === "production"
          ? VUE_APP_VERSION
          : `${VUE_APP_VERSION}${
              VUE_APP_BUILD ? ".beta-" + VUE_APP_BUILD : ".dev"
            }`,
      appType: "client",
      redactedKeys: [
        "access_token", // exact match: "access_token"
        /^password$/i, // case-insensitive: "password", "PASSWORD", "PaSsWoRd"
        /^cc_/ // prefix match: "cc_number" "cc_cvv" "cc_expiry"
      ],
      // Enhanced error filtering for chunk loading issues and browser extension errors
      onError: function(event) {
        const error = event.originalError || event.errors?.[0];
        if (error) {
          const errorMessage = error.message || error?.errorMessage;

          // Filter out browser extension runtime errors
          const isBrowserExtensionError =
            errorMessage.indexOf("runtime.sendMessage") !== -1 ||
            errorMessage.indexOf("Tab not found") !== -1 ||
            errorMessage.indexOf("Extension context invalidated") !== -1 ||
            errorMessage.indexOf("Could not establish connection") !== -1 ||
            errorMessage.indexOf("chrome-extension://") !== -1 ||
            errorMessage.indexOf("Failed to fetch") !== -1;

          if (isBrowserExtensionError) {
            // Don't report browser extension errors as they are external and not actionable
            return false;
          }

          // Filter out MongoDB Charts SDK internal errors
          const isMongoChartsSDKError =
            (errorMessage.indexOf("Cannot read properties of undefined") !==
              -1 &&
              errorMessage.indexOf("reading 'apiError'") !== -1) ||
            (error.stacktrace &&
              error.stacktrace.some(
                (frame: any) =>
                  frame.file && frame.file.indexOf("charts.mongodb.com") !== -1
              ));

          if (isMongoChartsSDKError) {
            // Don't report MongoDB Charts SDK internal errors as they are external and not actionable
            return false;
          }

          const isChunkLoadError =
            errorMessage.indexOf("Loading chunk") !== -1 ||
            errorMessage.indexOf("Loading CSS chunk") !== -1 ||
            error.name === "ChunkLoadError";

          if (isChunkLoadError) {
            // Add additional metadata for chunk loading errors
            event.addMetadata("chunkError", {
              isChunkError: true,
              chunkName:
                errorMessage.match(/Loading chunk ([^\s]+)/)?.[1] || "unknown",
              url: errorMessage.match(/https?:\/\/[^\s)]+/)?.[0] || "unknown"
            });
          }

          if (error?.status || error?.raw?.isAxiosError) {
            return false; // Ignore errors with a status property (e.g., HTTP errors)
          }
        }
        return true; // Continue with error reporting
      }
    })
  : { setUser: () => {}, addMetadata: () => {} };
if (VUE_APP_BUGSNAG_KEY) {
  BugsnagPerformance.start({ apiKey: VUE_APP_BUGSNAG_KEY });
}

export const bugSnag = function install(Vue: any) {
  Vue.prototype.$bugSnagClient = bugSnagClient;
};
